import { useEffect } from "react";
import { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import { toast } from "react-toastify";
import ReusableCard from "../ReusableComponent/ReusableCard";
import { useEqDetailsTabActionContext } from "../../Context/GlobalContext";

const AddMenuToEquGroup = (props) => {
  const {
    egDetails,
    equMenuList,
    equipmentGrpName,
    equipmentGrpId,
    handleCompleted,
    handleNext,
  } = props.data;
  const setTabSelected = useEqDetailsTabActionContext();
  const [menuList, setMenuList] = useState([]);
  const [selectedMenuList, setSelectedMenuList] = useState([]);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const overrideStrings = {
    selectSomeItems: localization.select,
    search: localization.search,
    selectAll: localization.select + " " + localization.all,
    selectAllFiltered:
      localization.select +
      " " +
      localization.all +
      "(" +
      localization.filtered +
      ")",
    allItemsAreSelected: localization.allItemSelected,
    noOptions: localization.noOptions,
  };

  useEffect(() => {
    if (equipmentGrpId) {
      setGlobalSpinner(true);
      EquipmentGroupActions.getAnlagegruppeMenupunktes(equipmentGrpId);
    }
  }, [equipmentGrpId]);

  useEffect(() => {
    function getMenuByEquGrpSuccess() {
      const res = equipmentGroupStore.getMenu();

      if (res.length > 0) {
        const tempArray = [];
        const tempMenuList = [];

        res.map((row, index) => {
          if (row.isSelected) {
            tempArray.push({ label: row.title, value: row.id });
          }
          tempMenuList.push({ label: row.title, value: row.id });
        });

        setSelectedMenuList(tempArray);
        setMenuList(tempMenuList);
        handleCompleted("AddMenu", tempArray.length > 0);
      } else {
        setMenuList([]);
      }

      setGlobalSpinner(false);
    }

    function getMenuByEquGrpFailure() {
      const res = equipmentGroupStore.getMenu();

      setMenuList([]);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_MENU_SUCCESS,
      getMenuByEquGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_MENU_FAILURE,
      getMenuByEquGrpFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_MENU_SUCCESS,
        getMenuByEquGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_MENU_FAILURE,
        getMenuByEquGrpFailure,
      );
    };
  }, []);

  useEffect(() => {
    function addOrUpdateMenuEquGrpSuccess() {
      toast.success(localization.menuAddedToEquipmentGroup);
      setGlobalSpinner(false);
      handleCompleted("AddMenu", true);
      setTabSelected(null);
      handleNext();
    }

    function addOrUpdateMenuEquGrpFailure() {
      const res = equipmentGroupStore.getAddOrUpdateMenuToEquGrp();
      setGlobalSpinner(false);
      toast.error(res);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS,
      addOrUpdateMenuEquGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE,
      addOrUpdateMenuEquGrpFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS,
        addOrUpdateMenuEquGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE,
        addOrUpdateMenuEquGrpFailure,
      );
    };
  }, []);

  const addMenuToEquGroup = (e) => {
    e.preventDefault();
    let selectedMenusIds = [];
    selectedMenuList.map((key, index) => {
      selectedMenusIds.push(key.value);
    });

    let menuData = {
      AnlagegruppeID: equipmentGrpId,
      Menupunktes: selectedMenusIds,
    };
    setGlobalSpinner(true);
    EquipmentGroupActions.addOrUpdateAnlagegruppeMenupunktes(menuData);
  };

  return (
    <>
      <div
        className="row d-flex justify-content-center"
        style={{ marginTop: "5%" }}
      >
        <ReusableCard
          title={localization.menu}
          func={addMenuToEquGroup}
          buttonStatus={selectedMenuList.length == 0}
          buttonname={localization.save}
        >
          <MultiSelect
            options={menuList}
            value={selectedMenuList}
            onChange={setSelectedMenuList}
            labelledBy="Select menu..."
            closeOnChangedValue={false}
            overrideStrings={overrideStrings}
          />
        </ReusableCard>
      </div>
    </>
  );
};

export default AddMenuToEquGroup;
